import _ from 'lodash';
import confluence from '../apis/confluence';
import { MDAQRT_SPACE_KEY } from '../constants/confluenceConstants';

const getConfluencePage = async (pageName) => {
  const params = new URLSearchParams();
  params.append('title', encodeURIComponent(pageName));
  params.append('expand', 'body.export_view');
  const response = await confluence.get(`rest/api/content?`, { params });

  if (response.data) {
    const page = _.find(response.data.results, {
      title: pageName,
      _expandable: {
        space: MDAQRT_SPACE_KEY,
      },
    });

    if (page) {
      return {
        pageId: page.id,
        title: page.title,
        html: page.body.export_view.value,
        editLink: page._links.edit, // eslint-disable-line no-underscore-dangle
      };
    }
  }

  return undefined;
};

export default getConfluencePage;
